import React from "react";
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

import logo from "../../assets/svgs/MG/Logo Proyecto.svg";

interface LoadingComponentProps {
  isPortrait: boolean;
  progress: number;
  showLoading: boolean;
  studioLoaded: boolean;
}

const LoadingComponent: React.FC<LoadingComponentProps> = ({ isPortrait, progress, showLoading, studioLoaded}) => {

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRadius: 8,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      height: 8,
      backgroundColor: '#FFFFFF',
      ...theme.applyStyles('dark', {
        backgroundColor: '#FFFFFF',
      }),
    },
    [`& .${linearProgressClasses.bar}`]: {
      height: 8,
      borderRadius: 8,
      background: `linear-gradient(to right, ${'#DD4040'}, ${'#DD4040'})`,
    },
  }));

  return (
    <div className={`loading-container ${showLoading ? '':'hide-container'}`}>

      <div className={`loading-content ${studioLoaded ? 'hide':''}`}>
        <img className={`loading-logo ${isPortrait ? 'portrait':''}`} src={logo} alt="" />
        <div className={`loading-progress ${isPortrait ? 'portrait':''}`}>
          <div className={`loading-progress-message ${isPortrait ? 'portrait':''}`}>
            La experiencia está iniciando, por favor espera
          </div>
          <div className={`loading-progress-bar ${isPortrait ? 'portrait':''}`}>
            <Box sx={{ width: '100%', height: '100%' }}>
              <BorderLinearProgress variant="determinate" value={progress} />
            </Box>  
          </div>
        </div>
      </div>

      <div className={`loading-post ${studioLoaded ? '' : 'hide'}`}>
        <img className={`loading-post-logo ${isPortrait ? 'portrait':''}`} src={logo} alt="" />
      </div>


      {/* //el otroo */}
    </div>
  );
};

export default LoadingComponent;